import WhIncomeService from '../services/wh-income.service';
import ApiService from '../services/api.service';
import { TokenService } from '../services/storage.service';
import Vue from 'vue';

const initialState = {
	tCountOfDocsFromSale: 0,
	pendingIncomeFromSaleError: {
		boolean: false,
		message: ''
	},
	responseFromReceive: {
		status: false,
		document: {}
	},
	currentPendingItems: [],
	currentPendingIncomeFromSale: {},
	incomeFromSaleLoader: false,
	totalPendingFromSale: 0,
	pendingIncomesFromSale: [],
	customDepartments: {},
	pendingIncomesFromSaleFields: [
		{
			key: 'id',
			label: '№',
			visible: true,
			class: '',
			changebale: false
		},
		{
			key: 'saleDate',
			label: 'incomes.date',
			visible: true,
			class: '',
			changebale: true
		},
		{
			key: 'regNumber',
			label: 'incomes.name',
			visible: true,
			changebale: true
		},
		{
			key: 'totalCount',
			label: 'sale.kol-vo',
			visible: true,
			class: 'textAlignCenter width12',
			changebale: true
		},
		{
			key: 'amountOfPaymentUzs',
			label: 'pos.sum',
			visible: true,
			class: 'textAlignCenter',
			changebale: true
		},
		// {
		// 	key: 'amountOfAfterPromoUzs',
		// 	label: 'sale.sum-skidka',
		// 	visible: true,
		// 	changebale: true,
		// 	class: 'textAlignCenter'
		// },
		{
			key: 'senderName',
			label: 'incomes.senderName',
			visible: true,
			changebale: true,
			class: 'textAlignCenter'
		},
		{
			key: 'senderDepartment',
			label: 'incomes.senderDepartment',
			visible: true,
			changebale: true,
			class: 'textAlignCenter width30_wordBreak'
		},
		{
			key: 'actions',
			label: 'incomes.actions',
			class: 'table_actions min-60 fixed-col',
			visible: true,
			changebale: false
		}
	],
	pendingIncomesFields: [
		{
			key: 'id',
			label: '№',
			visible: true,
			class: 'min-60',
			changebale: false
		},
		{
			key: 'regDate',
			label: 'incomes.date',
			visible: true,
			class: 'min-80',
			changebale: true
		},
		{
			key: 'regNumber',
			label: 'incomes.name',
			visible: true,
			class: 'min-200',
			changebale: true
		},
		{
			key: 'comment',
			label: 'comment',
			class: 'min-200',
			visible: true,
			changebale: true
		},
		{
			key: 'fromEmployeeName',
			label: 'incomes.from-employee',
			visible: true,
			class: 'min-150',
			changebale: true
		},
		{
			key: 'fromDepartmentName',
			label: 'incomes.fromDepartment',
			class: 'min-150',
			visible: true,
			changebale: true
		},
		{
			key: 'actions',
			label: 'incomes.actions',
			class: 'table_actions min-60 fixed-col',
			visible: true,
			changebale: false
		}
	],
	returnPending: null,
	loading: false,
	itemsForModal: [],
	sectors: [],
	pricingItem: null,
	priceIsNotDifferent: true,
	balance: 0,
	currentItemBalanceError: false,
	currentPricingItemError: false,
	whDocSaveDisabled: false,
	filteredItems: [],
	itemsForItemConvert: [],
	viewforModalItems: [],
	itemsNotKirim: [],
	fromIncomeToTransfer: {
		status: false,
		allItems: [],
		notPossibleItems: [],
		toDepartment: null,
		fromDepartment: null,
		currency: null
	},
	currentWhItems: [],
	pendingIncomePackages: [],
	packListItems: [],
	totalPendingPackages: 0,
	receivedResponse: null,
	acceptedResponse: null,
	newDocument: {
		id: null,
		comment: null,
		action: 'KIRIM',
		documentType: 'NAKLADNOY',
		fromDepartmentId: null,
		fromDepartmentName: null,
		toDepartmentId: localStorage.getItem('dep_id'),
		toDepartmentName: null,
		fromEmployeeId: null,
		fromEmployeeName: null,
		toEmployeeId: null,
		toEmployeeName: '',
		responsible1Id: null,
		responsible1Name: '',
		responsible2Id: null,
		responsible2Name: '',
		regNumber: '',
		regDate: null,
		contragentId: null,
		contragentName: '',
		reason: null,
		initiatorId: null,
		fromCurrencyRate: null,
		currencyId: null,
		toCurrencyRate: null,
		whItems: []
	},
	currentPackDocId: null,
	pendingPacksCount: 0,
	foundItemsFromXls: [],
	notFoundItemsFromXls: []
};
const state = () => ({ ...initialState });
const getters = {
	columnsPendingIncomes: state => {
		return state.pendingIncomesFields;
	}
};
const actions = {
	async addNotFoundItemsToDatabase({ commit }, newItems) {
		try {
			commit('setLoading', true);
			const response = await WhIncomeService.addNotFoundItemsToDatabase(
				newItems
			);
			commit('setNotFoundItemsResponse', response.data);
			commit('setPendingIncomeFromSaleError', {
				message: '',
				boolean: false
			});
			commit('setLoading', false);
			return true;
		} catch (error) {
			commit('setLoading', false);
			let response = JSON.parse(error.request.response);
			commit('setPendingIncomeFromSaleError', {
				message: response.message,
				boolean: true
			});
			return false;
		}
	},
	async getTCountOfDocsFromSale({ commit }) {
		try {
			const response = await WhIncomeService.getTCountOfDocsFromSale();
			commit('setTCountOfDocsFromSale', response.data);
			return true;
		} catch {
			return false;
		}
	},
	async receivePendingIncomeFromSale({ commit }, depIdAndPayload) {
		try {
			commit('setLoading', true);
			const response = await WhIncomeService.receivePendingIncomeFromSale(
				depIdAndPayload
			);
			commit('setLoading', false);
			commit('setResponseFromReceive', response.data);
			commit('setPendingIncomeFromSaleError', {
				message: '',
				boolean: false
			});
			return true;
		} catch (error) {
			commit('setLoading', false);
			let response = JSON.parse(error.request.response);
			commit('setPendingIncomeFromSaleError', {
				message: response.message,
				boolean: true
			});
			commit('setResponseFromReceive', initialState.responseFromReceive);
			return false;
		}
	},
	async fetchPendingIncomeFromSaleById({ commit }, docId) {
		try {

			commit('setLoading', true);
			const response = await WhIncomeService.fetchPendingIncomeFromSaleById(
				docId
			);
			commit('setLoading', false);
			commit('setCurrentIncomeFromSale', response.data);
			return true;
		} catch (e) {
			commit('setLoading', false);
			return false;
		}
	},
	async fetchPendingIncomesFromSale({ commit }, payload) {
		try {
			const response = await WhIncomeService.fetchPendingIncomesFromSale(
				payload
			);
			commit('setIncomesFromSale', response.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async getPendingIncomesCount({ commit }) {
		try {
			let payload = {
				user: 'SAMO-API-USER',
				password: 'samo-api-password'
			};
			let response = await WhIncomeService.getPendingIncomesCountService(
				payload
			);
			commit('setPendingIncomesCount', response.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async checkPendingIncomeItems({ commit, state }, items) {
		try {
			state.newDocument.whItems = items;
			const response = await WhIncomeService.checkPendingIncomeItems(
				state.newDocument
			);
			commit('setCheckPendingResponse', response.data);
			// commit('setReceivedPendingIncomeError', null);
			return true;
		} catch (e) {
			//let response = JSON.parse(e.request.response);
			// commit('setReceivedPendingIncomeError', response.message);
			return false;
		}
	},
	async receivePendingIncome({ commit, state }, items) {
		try {
			state.newDocument.whItems = items;
			const response = await WhIncomeService.receivePendingIncome(
				state.newDocument
			);
			commit('setReceivedPendingIncome', response.data);
			commit('setReceivedPendingIncomeError', null);
			return true;
		} catch (e) {
			if (e.request) {
				let response = JSON.parse(e.request.response);
				commit('setReceivedPendingIncomeError', response.message);
			}
			commit('setReceivedPendingIncomeError', true);
			return false;
		}
	},
	async acceptByManufacturer({ commit, state }, payload) {
		try {
			payload.user = 'SAMO-API-USER';
			payload.password = 'samo-api-password';
			const response = await WhIncomeService.acceptByManufacturer(
				payload
			);
			commit('setAcceptedPendingIncome', response.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async getPendingIncomes({ commit, state }) {
		try {
			let payload = {
				user: 'SAMO-API-USER',
				password: 'samo-api-password'
			};
			ApiService.removeHeader();
			const response = await WhIncomeService.getPendingIncomesFromManufactureApi(
				payload
			);
			ApiService.setHeader();
			commit('setPendingIncomesFromManufacture', response.data);
			return true;
		} catch (e) {
			ApiService.setHeader();
			return false;
		}
	},
	async getPackListAction({ commit, state }, id) {
		try {
			let payload = {
				user: 'SAMO-API-USER',
				password: 'samo-api-password',
				id: id,
				doc_id: state.newDocument.id
			};
			const response = await WhIncomeService.getPackList(payload);
			commit('setPackList', response.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async returnPendingIncomeAction({ commit }, docId) {
		try {
			const response = await WhIncomeService.returnPending(docId);
			commit('returnPendingIncomeMutation', response.data);
			return true;
		} catch (e) {
			return false;
		}
	}
};

const mutations = {
	setNotFoundItemsResponse(state, response) {
		state.notFoundItemsResponse = response;
	},
	setTCountOfDocsFromSale(state, response) {
		state.tCountOfDocsFromSale = response;
	},
	setPendingIncomeFromSaleError(state, payload) {
		state.pendingIncomeFromSaleError = payload;
	},
	setResponseFromReceive(state, payload) {
		state.responseFromReceive = payload;
		if (!payload.status && payload.document.saleItemDtos) {
			state.currentPendingItems = payload.document.saleItemDtos;
		}
	},
	setCurrentIncomeFromSale(state, payload) {
		state.currentPendingIncomeFromSale = payload;
		if (payload) {
			if (Array.isArray(payload.saleItems)) {
				state.currentPendingItems = payload.saleItems;
			} else {
				state.currentPendingItems = JSON.parse(payload.saleItems);
			}
		}
	},
	setIncomesFromSale(state, payload) {
		state.pendingIncomesFromSale = payload.saleTransactions;
		state.pendingIncomesFromSale.forEach(el => {
			el.payments = JSON.parse(el.payments);
			el.saleItems = JSON.parse(el.saleItems);
		});
		state.totalPendingFromSale = payload.total;
	},
	setCheckPendingResponse(state, res) {
		state.newDocument = res;
		res.whItems.forEach((el, index) => {
			if (state.packListItems[index].id == el.id) {
				Vue.set(
					state.packListItems[index],
					'_rowVariant',
					el['_rowVariant']
				);
				// state.packListItems[index] = el;
			}
		});
	},
	setPendingIncomesCount(state, payload) {
		state.pendingPacksCount = payload.total;
	},
	setCurrentPackDocId(state, payload) {
		state.currentPackDocId = payload;
	},
	setReceivedPendingIncome(state, res) {
		state.receivedResponse = res;
	},
	setReceivedPendingIncomeError(state, res) {
		state.receiveErrorMsg = res;
	},
	setAcceptedPendingIncome(state, res) {
		state.acceptedResponse = res;
	},
	setPendingIncomesFromManufacture(state, res) {
		state.pendingIncomePackages = res.data;
		state.totalPendingPackages = res.total;
	},
	setPackList(state, res) {
		state.packListItems = res.data;
	},
	returnPendingIncomeMutation(state, response) {
		state.returnPending = response;
	},
	setLoading(state, payload) {
		state.loading = payload;
	}
};
export const whIncomeModule = {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
